import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import withAuth from '../../decorators/withAuth';
import withIsFocused from '../../decorators/withIsFocused';
import { rootAction } from '../../redux';
import { getDefaultShippingFeesActions } from '../../redux/actions/getDefaultShippingFeesActions';
import { makeBillDetailIsLoading } from '../../redux/selectors/billDetail';
import {
  cartContentHasDataSelector,
  cartContentIdsSelector,
  cartContentItemsAttrSelector,
  cartContentLoadingSelector,
  outOfStockHasDataSelector,
} from '../../redux/selectors/cartContentSelector';
import { makeDeliveryMethodHasError } from '../../redux/selectors/checkoutPageSelectors';
import { getCurrentSubmitBillDataByName } from '../../redux/selectors/transactionDetail';
import CartPage from './CartPage';

const {
  loadCartContent,
  logAnalyticsEvent,
  resetTransaction,
  selectedAllCart,
  updateSelectedCart,
  getMemberProfileActions,
  getFreeDeliveryActions,
} = rootAction.actionsList;

const mapStateToProps = () => {
  const selector = createStructuredSelector({
    isCartContentLoading: cartContentLoadingSelector(),
    isSubtotalLoading: makeBillDetailIsLoading(),
    hasCartContent: cartContentHasDataSelector(),
    hasOutOfStock: outOfStockHasDataSelector(),
    cartIds: cartContentIdsSelector(),
    outOfStockCartIds: cartContentIdsSelector('outOfStock'),
    cartListAnalyticsData: cartContentItemsAttrSelector(),
    hasDeliveryError: makeDeliveryMethodHasError(),
    currentMethod: getCurrentSubmitBillDataByName('delivery_mode'),
  });

  return state => selector(state);
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      loadCartContent: loadCartContent.request,
      updateSelectedCart,
      selectedAllCart,
      getMemberProfile: getMemberProfileActions.request,
      getFreeDelivery: getFreeDeliveryActions.request,
      getDefaultShippingFees: getDefaultShippingFeesActions.request,
      resetTransaction,
      logEvent: logAnalyticsEvent,
    },
    dispatch
  );
};

export const CartPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuth(CartPage));

export default withIsFocused(CartPageContainer as typeof CartPage);
